class SeededRandom {
  modulus = 2 ** 31 - 1 // a large prime number
  multiplier = 48271 // another prime number
  increment = 0 // often zero in most LCG implementations
  seed = 0

  constructor(seed: number) {
    this.seed = seed % this.modulus
    if (this.seed <= 0) this.seed += this.modulus - 1
    if (Number.isNaN(this.seed)) throw new Error('seed must be a number')
  }

  next() {
    this.seed = (this.multiplier * this.seed + this.increment) % this.modulus
    return this.seed / this.modulus
  }
}

function makeCryptoRandomForTests(seedValue: number) {
  const rng = new SeededRandom(seedValue)
  return (arr: Uint8Array) => arr.map(() => 256 * rng.next())
}
function makeMathRandomForTests(seedValue: number) {
  const rng = new SeededRandom(seedValue)
  return () => rng.next()
}

export let fakeCryptoRandom:
  | { getRandomValues: (arr: Uint8Array) => Uint8Array }
  | undefined
export let fakeMathRandom: (() => number) | undefined
export const mockRandom = (seedValue?: number) => {
  const seed = seedValue ?? 42
  fakeCryptoRandom = { getRandomValues: makeCryptoRandomForTests(seed) }
  fakeMathRandom = makeMathRandomForTests(seed)
}
export const restoreRandom = () => {
  fakeCryptoRandom = undefined
  fakeMathRandom = undefined
}
